import { useQuery } from '@tanstack/react-query';

import { fetchBillingDocument } from '../api/FetchBillingDocument';

export const useFetchBillingDocument = (uuid: string, attachmentId: number) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['billing', uuid, 'document', attachmentId],
    queryFn: ({ signal }) => fetchBillingDocument(uuid, attachmentId, signal),
    // A refetched blob is a new object: the viewer would load and render the whole pdf again
    staleTime: Infinity,
  });

  return {
    documentBlob: data,
    isLoading,
    isError,
  };
};
